import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import FechamentoDeFolha from 'Interface/FechamentosDeFolha';
import { useRemoverFechamentoDeFolhaMutation } from 'View/Service/Default/FechamentosDeFolha';

interface Props {
  dados: FechamentoDeFolha;
  btnRemover?: boolean;
  btnAssinar?: boolean;
}

const Lista = ({
  dados,
  btnRemover = true,
  btnAssinar = false,
}: Props): React.ReactElement => {
  const toast = useToast();
  const [removerFolha] = useRemoverFechamentoDeFolhaMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerFolha({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <Link
          to={
            !btnAssinar
              ? `/usuarios/editar/${dados.vinculo_empregaticio?.usuario_id}/fechamentos-de-folha/editar/${dados.id}`
              : `/fechamentos-de-folha/assinar/${dados.id}`
          }
          className="text-decoration-none"
        >
          {dados.inicio.data().toLocaleString()} até{' '}
          {dados.termino.data().toLocaleString()}
        </Link>
        <small className="text-muted fs-6 d-block">
          {dados.vinculo_empregaticio?.empresa?.nome_fantasia}
        </small>
      </div>
      <BrowserView className="d-flex align-items-center">
        {dados.assinatura && (
          <div className="ms-5 fs-5 text-end">
            <div className="fs-4">
              <img src={dados.assinatura} alt="" height={50} />
              <small className="text-muted d-block" style={{ fontSize: 10 }}>
                {dados.data_da_assinatura
                  ?.data()
                  .toLocaleString(DateTime.DATETIME_SHORT)}
              </small>
            </div>
          </div>
        )}
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.salario?.moeda()}
            <small className="text-muted fs-6 d-block">Salário</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
            <small className="text-muted fs-6 d-block">Criado em</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          {btnRemover && (
            <Botao
              icone="trash"
              tema="danger"
              confirmacao="Você tem certeza que deseja remover esse registro? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
